define('Components/AboutNavByDesireWidget/js/models/AboutNavByDesireWidgetInstanceModel',['jquery','underscore',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($,_, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'AboutNavByDesireWidgetModel',
            // Parent functions
            getChildren:function(){
                var model = this,
                    template = model.p('template'),
                    children = model.get('children') || false,
                    collection = model.get('collection');
                if(template === 'parent' && !children){
                    children = [];
                    collection.getLayouts().each(function(layout){
                        layout.getInstances().each(function(widgetInstance){
                            if(widgetInstance.p('template')==='child'){
                                children.push(widgetInstance);
                            }
                        })
                    });
                    model.set('children',children);
                    console.log('children',children);
                }
                return _(children);
            },
            getChild:function(id_widget_instance){
                return this.getChildren().findWhere({id:id_widget_instance});
            },
            getChildrenGrouped:function(){
                var children = this.getChildren(), groups = [], group = [];
                children.each(function(child,i){
                    if(app.isDesktop() && i%4===0 && i!==0){
                        groups.push(_(group));
                        group = [];
                    }
                    group.push(child);
                })
                if(group.length) groups.push(_(group));
                console.log('groups',groups);
                return _(groups);
            },
            // Child functions
            getCategory:function(){
                return app.getCategory(this.p('id_category'));
            },
            getTitle:function(){
               var cat = this.getCategory();
               return this.p('title') || (cat ? cat.getTitle() : '');
            },
            getTitleSize:function(){
               var size = this.getTitle(),
                   length = size.length;
               return length < 13 ? 'large' : length < 25 ? 'medium' : 'small' ;
            },
            getSubtitle:function(){
               return this.p('subtitle') || 'desc';
            },
            getProducts:function(){
                var products = [], model = this;
                for(var i=1; i<=4; i++){
                    var id = model.p('id_product_'+i),
                        product = app.getProduct(id);
                    if(product && product.isVisibleInContext()){
                        products.push(product);
                    }
                }
                return _(products);
            },
            //
        })
    });
